var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M43,23A20,20,0,1,1,23,3,20,20,0,0,1,43,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 23 5 C 18.19202995300293 5 13.67182922363281 6.872329711914062 10.27207946777344 10.27207946777344 C 6.872329711914062 13.67182922363281 5 18.19202995300293 5 23.00000953674316 C 5 27.80797958374023 6.872329711914062 32.32817077636719 10.27207946777344 35.72792053222656 C 13.67182922363281 39.12767028808594 18.19202995300293 41 23 41 C 27.80797958374023 41 32.32817077636719 39.12767028808594 35.72792053222656 35.72792053222656 C 39.12767028808594 32.32817840576172 41 27.80797958374023 41 23.00000953674316 C 41 18.19202995300293 39.12767028808594 13.67182922363281 35.72792053222656 10.27207946777344 C 32.32817077636719 6.872329711914062 27.80797958374023 5 23 5 M 23 3 C 34.04570007324219 3 43 11.95431137084961 43 23.00000953674316 C 43 34.04570007324219 34.04570007324219 43 23 43 C 11.95431137084961 43 3 34.04570007324219 3 23.00000953674316 C 3 11.95431137084961 11.95431137084961 3 23 3 Z M 43 23 L 43 23.00000953674316 C 43 23 43 23 43 23 Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18,28l8-8-8-8",
    transform: "translate(2 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12,18H28",
    transform: "translate(0 2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.0520b8c6f683fa737b83dd9d7dbbed73.svg";
export { ForwardRef as ReactComponent };